import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE, DOWNLOAD_EXCEL } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// ChildCategory - Get All (Read)
export const GetAll = createAsyncThunk(
  "admin/sample-management/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.SampleManagement.SampleManagement
        }?unique_id=${filter?.unique_id ||
          ""}&method_of_testing=${filter?.method_of_testing ||
          ""}&tat=${filter?.tat ||
          ""}&sample_management_status_id=${filter?.sample_management_status_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.perPage ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date ||
          ""}&customer_id=${filter?.customer_id || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ChildCategory - Get (Read)
export const GetSingle = createAsyncThunk(
  "admin/sample-management/get-single",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.SampleManagement.SampleManagement}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ChildCategory - Create (Add)
export const Create = createAsyncThunk(
  "admin/sample-management/create",
  async (sendData, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.SampleManagement.SampleManagement, sendData);
      console.log(res, "res uuuuuuuuuuuuu");

      if (res.success) {
        return res;
      } else {
        return rejectWithValue(res);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Update = createAsyncThunk(
  "admin/sample-management/update",
  async ({ id, sendData }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.SampleManagement.SampleManagement}/${id}`,
        sendData,
      );
      if (res.success) {
        return res;
      } else {
        return rejectWithValue(res);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Delete = createAsyncThunk(
  "admin/sample-management/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.SampleManagement.SampleManagement}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetSampleCounter = createAsyncThunk(
  "admin/sample-management/count",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.SampleManagement.SampleManagementCounter}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "sample_management",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,

    counter: {
      total: 0,
      scheduled: 0,
      in_progress: 0,
      verified: 0,
      pending_review: 0,
    },
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        //state.data = action.payload?.data?.data || [];
        state.data = Array.isArray(action.payload?.data?.data)
          ? action.payload.data.data.filter(
              (item) => item && typeof item === "object",
            )
          : [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
        state.data = state.data.filter((item) => item && item.id);
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSampleCounter.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSampleCounter.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.counter = action.payload?.data || state.counter;
        state.data = state.data.filter((item) => item && item.id);
      })
      .addCase(GetSampleCounter.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((item) => item && item.id);
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        //state.data.unshift(action.payload.data);
        state.data = state.data.filter((item) => item && item.id);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (country) => country.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
        state.data = state.data.filter((item) => item && item.id);
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((item) => item?.id !== action.payload); // Remove the country with the deleted id
        state.data = state.data.filter((item) => item && item.id);
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
